<script lang="ts">
	// vercel analytics
	import { dev } from '$app/environment';
	import { inject } from '@vercel/analytics';
	import { browser } from '$app/environment';
	const env = import.meta.env.VITE_VERCEL_ENV || 'development';
	inject({ mode: dev ? 'development' : 'production' });
	// style
	// import '@picocss/pico'
	import '../app.scss';
	import { resolvedTheme } from '$lib/theme';
	import '@fontsource/inter';
	import '@fontsource/jetbrains-mono';
	// sveltekit
	import type { LayoutServerData } from './$types';
	import { onDestroy } from 'svelte';
	import { onMount } from 'svelte';
 	import { invalidate } from '$app/navigation';
	
	// Speed Insights
	import { injectSpeedInsights } from '@vercel/speed-insights/sveltekit';
	injectSpeedInsights();

	// Declare a reactive variable 'data' that can be passed into this Svelte component from a parent component
	// export let data: LayoutServerData;
	onDestroy(
		resolvedTheme.subscribe((value) => {
			if (!browser) return;
			document.documentElement.classList.remove('light', 'dark');
			document.documentElement.classList.add(value);
		})
	);
</script>

<svelte:head>
	<link rel="apple-touch-icon" sizes="180x180" href="/apple-touch-icon.png">
	<link rel="icon" type="image/png" sizes="32x32" href="/favicon-32x32.png">
	<link rel="icon" type="image/png" sizes="16x16" href="/favicon-16x16.png">
	<link rel="manifest" href="/site.webmanifest">
	<meta name="msapplication-TileColor" content="#da532c">
	<meta name="theme-color" content="#ffffff">
	<!-- <title>TeamTeacher</title> -->
</svelte:head>

<!-- <HomeHeader /> -->
<slot />
